
// round a value to 3 decimals
export default {
	name: 'RoundValue',
	handler: {
		init: function (element, valueAccessor, allBindingsAccessor) {
			let value = valueAccessor();
			// let allBindings = allBindingsAccessor();

			let valueUnwrapped = ko.utils.unwrapObservable(value);

			$(element).text(parseFloat(valueUnwrapped.toFixed(3)));
		}
	}
};
